import { Box, Center, Heading, Icon } from '@chakra-ui/react';

import { sansFonts } from '@inspire/ui/static';
import Span from '@inspire/ui/chakra/Span';
import { RightArrowIcon } from '@inspire/ui/icons';
import LinkButton from 'components/general/LinkButton';
import { INSCRIPTION_PATH } from 'lib/paths';

const HeroSection = ({ title, subtitle, Animation, text, cta, onCTAClick }) => (
  <>
    <Box textAlign="center">
      <Heading
        as="h2"
        mt={0}
        mb={2}
        fontFamily={sansFonts}
        bg="white"
        pos="relative"
        zIndex={1}
        display="inline"
      >
        {title}
      </Heading>
    </Box>

    <Box
      display={{ md: 'flex' }}
      flexDirection="row-reverse"
      alignItems="center"
    >
      <Box width={{ md: '50%' }}>
        <Animation />
      </Box>

      <Box width={{ md: '50%' }}>
        <Heading
          as="h3"
          size="md"
          my={5}
          fontFamily={sansFonts}
          textAlign={['center', null, 'left']}
        >
          <Span
            borderBottom="1px solid black"
            fontWeight="500"
            display="inline-block"
          >
            {subtitle}
          </Span>
        </Heading>

        <Box>{text}</Box>
      </Box>
    </Box>

    <Center mt={5}>
      <LinkButton
        href={INSCRIPTION_PATH}
        borderRadius="25px"
        onClick={onCTAClick}
      >
        {cta} <Icon ml={2} as={RightArrowIcon} />
      </LinkButton>
    </Center>
  </>
);

export default HeroSection;
